import { useIntl } from 'react-intl';
import { FormControl, FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material';
import TFFDialog from '../../../styled-components/TFFDialog';
import TFFTypography from '../../../styled-components/TFFTypography';
import type { RegionData } from '.';

type Props = {
  regions: RegionData[];
  selectedRegion: RegionData;
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  onChange: (region: RegionData) => void;
};

const AtComRegionsDialog: React.FC<Props> = ({ regions, selectedRegion, isOpen, onConfirm, onCancel, onChange }) => {
  const intl = useIntl();

  return (
    <TFFDialog
      dialogId="at-com-regions-dialog"
      isOpen={isOpen}
      confirmButton
      confirmButtonText={intl.formatMessage({ id: 'global.continue' })}
      onConfirm={onConfirm}
      cancelButton
      cancelButtonText={intl.formatMessage({ id: 'global.cancel' })}
      onCancel={onCancel}
      header={
        <TFFTypography
          text={intl.formatMessage({ id: 'global.attention' }).toUpperCase()}
          variant="lead"
          size="large"
          fontWeight="bold"
        />
      }
      extraStyle={{
        padding: '10px',
      }}
    >
      <TFFTypography
        text={intl.formatMessage({ id: 'atcom.RegionsDialog.description' })}
        variant="base"
        size="medium"
      />
      <FormControl style={{ width: '100%', marginTop: '20px' }}>
        <RadioGroup
          aria-labelledby="radio-buttons-group-label"
          name="radio-buttons-group"
          style={{ marginLeft: '20px' }}
          value={selectedRegion.id}
        >
          {regions.map(region => {
            return (
              <FormControlLabel
                key={region.id}
                value={region.id}
                control={<Radio />}
                label={
                  <>
                    <Typography variant="h6" align="left" color="primary" fontWeight="bold">
                      {region.name}
                    </Typography>
                  </>
                }
                onChange={() => {
                  onChange(region);
                }}
              />
            );
          })}
        </RadioGroup>
      </FormControl>
    </TFFDialog>
  );
};

export default AtComRegionsDialog;
